module.exports = __webpack_public_path__ + "static/AVENTURA-Klauzula-informacyjna-do-formularza-zapisu-ccee54ffd48900844c66882ebf8c200f.pdf";